module.exports = __webpack_public_path__ + "static/img/news1_1.4a7f3a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news1_1.jpg
// module id = AfEJ
// module chunks = 0